"use client";

import Container from "@mui/material/Container"; // Local CUSTOM COMPONENTS
import Grid from "@mui/material/Grid";
import { usePathname } from "next/navigation";
import React from "react";
import Navigation from "./default/layout/navigation";
import { OrderDetailsPageView, OrdersPageView } from "./default/orders/page-view";

export interface VariantProps {
  menu: Array<{
    title: string;
    list: Array<{
      title: string;
      href: string;
      type: "order" | "wishlist" | "support" | "profile" | "address" | "payment";
    }>;
  }>;
  /** @default "product/" */
  prefixProductDetailURL?: string;
}

const CustomerDashboardLayout = (props: VariantProps) => {
  const pathname = usePathname();
  const { menu, active } = React.useMemo(() => {
    const menuParsed = props.menu ?? [
      {
        title: "Bảng Điều Khiển",
        list: [
          {
            href: "/orders",
            title: "Tất cả đơn hàng",
            type: "order",
          },
        ],
      },
    ];

    const active = menuParsed.reduce<any>((acc, cur) => {
      const item = cur.list.find(({ href }) => href.split("/")[1] === pathname.split("/")[1]);
      if (item) return item;
      return acc;
    }, undefined);

    return { menu: menuParsed ?? [], active };
  }, [props.menu, pathname]);

  const render = React.useMemo(() => {
    if (!active) return null;

    if (active.type === "order") {
      const isDetail = !!pathname.split("/")[2];
      if (isDetail) {
        return <OrderDetailsPageView order={{}} />;
      } else {
        return <OrdersPageView orders={[]} />;
      }
    }

    return null;
  }, [active]);

  return (
    <Container sx={{ my: 4 }}>
      <Grid container spacing={3}>
        <Grid item md={3} xs={12} sx={{ display: { xs: "none", sm: "none", md: "block" } }}>
          {false && <Navigation menu={menu} />}
        </Grid>

        <Grid item md={12} xs={12}>
          {render}
        </Grid>
      </Grid>
    </Container>
  );
};

export default CustomerDashboardLayout;
